<div class="overflow-hidden">
    <app-banner></app-banner>
    <app-feature></app-feature>
    <app-about></app-about>
    <app-what-is></app-what-is>
</div>
<app-news></app-news>
<app-tokenomics></app-tokenomics>
<app-how-to-buy></app-how-to-buy>
<app-roadmap></app-roadmap>
<app-faq></app-faq>